import { useContext } from 'react'
import { AppContext, AppContextType } from '../../AppContext'
import clsx from 'clsx'
import { SimpleSelect } from '@/UIComponents2/Select/SimpleSelect'
import { useTranslation } from 'react-i18next'

export default function CalendarSelection() {
    const { t } = useTranslation()
    const { state: appState, dispatch: appDispatch } = useContext(AppContext) as AppContextType

    const calendarIntegrationTypes = [
        { value: '_none', label: t('None') },
        { value: 'google', label: t('Google Calendar') },
    ]

    const { calendarIntegrationSelection } = appState.appSettings

    const onChange = (value: string) => {
        if (value === '_none' || value === 'google') {
            if (value === '_none') {
                value = ''
            }
            // @ts-ignore
            appDispatch({
                type: 'update_app_settings',
                value: { calendarIntegrationSelection: value },
            })
        }
    }

    return (
        <div className={clsx('w-full grid grid-cols-[30%_1fr] items-center')}>
            <div>{t('Calendar')}</div>
            <SimpleSelect
                value={calendarIntegrationSelection || '_none'}
                onChange={(value: string) => onChange(value)}
                items={calendarIntegrationTypes}
            />
        </div>
    )
}
